










import VueOptions from '@utils/VueOptions'
import MediaCarousel from '@ui/MediaSelector/MediaCarousel'

settings =
  name: 'FormFieldMedia'

  vue:
    props: ['value', 'errors', 'options', 'tags']

    components: {
      MediaCarousel,
    }

    data: ->
      images: @value

    computed:
      mediaKits: ->
        @options

    mounted: ->
      @$emit 'focus'

    methods:
      hiInputChange: (images) ->
        @$emit 'input', images
        @$emit 'change', images

      hiUpload: ->
        @$emit 'onUpload'

export default VueOptions.vue settings
